import React from 'react'
import {
  Button,
  Row,
  Col,
  Radio,
  Select,
  Icon,
  Input,
  message,
  Modal,
  notification,
} from 'antd'
import Headers from '../../../components/Headers'
import NProgress from 'nprogress'
import noQuestion from '../../../assets/images/noQuestion.png'
import up from '../../../assets/images/up.png'
import deleteImg from '../../../assets/images/delete.png'
import dragImg from '../../../assets/images/drag.png'
import {
  fetchQuestionDetails,
  fetchSaveQuestion,
  fetchQuestionList,
} from '../../../api/question'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import './index.scss'
var timeId
let throttle = true
const timeList = []
for (let i = 1; i <= 25; i++) {
  timeList.push(i * 5)
}
//初始化数据
const getItems = (count) =>
  Array.from({ length: count }, (v, k) => k).map((k) => ({
    id: `item-${k + 1}`,
    content: `this is content ${k + 1}`,
  }))

// 重新记录数组顺序
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list)

  const [removed] = result.splice(startIndex, 1)

  result.splice(endIndex, 0, removed)
  return result
}

const grid = 8

// 设置样式
const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  padding: 0,
  margin: 0,
  // 拖拽的时候背景变化
  border: isDragging ? '1px solid #ffffff' : '1px solid #ffffff',

  // styles we need to apply on draggables
  ...draggableStyle,
})

const BreadCrumbData = [
  { path: '/page/business/business', name: '运营商管理' },
  { path: '/page/business/business', name: '运营商管理' },
  { path: '/page/business/business', name: '查看点位' },
  { path: '/goods/grantRecord', name: '设置问卷' },
]
class Question extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      setState: false,
      capsuleId: '',
      title: '',
      minTime: 40,
      top: 0, //滚动条高度
      question: [],
      questionnaireList: [],
      info: {
        title: '',
        minTime: 5,
        topicList: [],
      },
      selected: '', //选中拿来复制的id
      queryType: '',
      release_visible: false,
      success_visible: false,
      fail_visible: false,
      countDown: 3,
    }
    this.onDragEnd = this.onDragEnd.bind(this)
  }
  renderNotification = () => {
    this.setInfo()
    // if (throttle) {
    //   throttle = false;
    //   let date = new Date();
    //   let m = date.getMinutes();
    //   m = m < 10 ? "0" + m : m;
    //   let h = date.getHours();
    //   h = h < 10 ? "0" + h : h;
    //   notification.open({
    //     className: "saveTips",
    //     duration: 3,
    //     top: 160,
    //     message: "",
    //     description: h + ":" + m + "问卷自动保存成功",
    //   });
    //   setTimeout(() => {
    //     throttle = true;
    //   }, 60000);
    // }
  }
  onDragEnd(result) {
    if (!result.destination) {
      return
    }

    const items = reorder(
      this.state.info.topicList,
      result.source.index,
      result.destination.index
    )
    this.setState({
      info: { ...this.state.info, topicList: items },
    })
  }
  ScrollToTop() {
    document.getElementsByClassName('container')[0].scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }
  getDRAFTQuestion = () => {
    fetchQuestionDetails({
      capsuleId: this.state.capsuleId,
      state: 'DRAFT',
    }).then((res) => {
      if (res.success) {
        res.data.list.forEach((item) => {
          if (item.option) {
            try {
              item.options = JSON.parse(item.option)
              delete item.option
            } catch (error) {}
          }
          item.position = item.position + ''
        })

        this.setState({
          info:
            JSON.parse(localStorage.getItem('info')) &&
            JSON.parse(localStorage.getItem('info')).topicList.length != 0 &&
            JSON.parse(localStorage.getItem('info')).capsuleId ==
              this.props.match.params.id
              ? JSON.parse(localStorage.getItem('info'))
              : {
                  ...this.state.info,
                  minTime: res.data.minTime,
                  topicList: res.data.list,
                },
        })
      }
    })
  }
  getRELEASEQuestion = () => {
    fetchQuestionDetails({
      capsuleId: this.state.capsuleId,
      state: 'RELEASE',
    }).then((res) => {
      if (res.success) {
        res.data.list.forEach((item) => {
          if (item.option) {
            try {
              item.options = JSON.parse(item.option)
              delete item.option
            } catch (error) {}
          }
        })
        this.setState({
          minTime: res.data.minTime,
          question: res.data.list,
        })
      }
    })
  }
  getQuestionList = () => {
    fetchQuestionList({ type: 'capsule' }).then((res) => {
      if (res.success) {
        if (res.data) {
          res.data = res.data.filter(
            (item) => item.capsuleId != this.state.capsuleId
          )
          this.setState({
            questionnaireList: res.data,
          })
        }
      }
    })
  }
  selectChange = (e, option) => {
    let queryType = ''
    if (option.props.item.materialsId) {
      queryType = 'materialsId'
    }
    if (option.props.item.capsuleId) {
      queryType = 'capsuleId'
    }
    this.setState({
      selected: e,
      queryType,
    })
  }
  copyQuestionaire = () => {
    fetchQuestionDetails({
      [this.state.queryType]: this.state.selected,
      state: 'RELEASE',
    }).then((res) => {
      if (res.success) {
        res.data.list.forEach((item) => {
          if (item.option) {
            try {
              item.options = JSON.parse(item.option)
              delete item.option
            } catch (error) {}
          }
          item.position = item.position + ''
        })
        this.setState({
          info: {
            ...this.state.info,
            minTime: res.data.minTime,
            topicList: res.data.list,
          },
        })
        this.renderNotification()
      }
    })
  }
  setInfo = () => {
    var that = this
    localStorage.setItem(
      'info',
      JSON.stringify({
        ...that.state.info,
        capsuleId: this.props.match.params.id,
      })
    )
  }
  componentDidMount() {
    var that = this
    window.onbeforeunload = function () {
      that.setInfo()
    }
    this.setState({
      title: sessionStorage.getItem('questionTitle'),
      info: {
        ...this.state.info,
        title: sessionStorage.getItem('questionTitle'),
      },
    })
    document.getElementsByClassName('container')[0].onscroll = (e) => {
      var top = document.getElementsByClassName('container')[0].scrollTop
      this.setState({
        top,
      })
    }
    NProgress.start()
    this.setState(
      {
        capsuleId: this.props.match.params.id,
      },
      () => {
        this.getDRAFTQuestion()
        this.getRELEASEQuestion()
        this.getQuestionList()
      }
    )

    NProgress.done()
  }
  renderQuestion = () => {
    const list = this.state.question

    return list.map((item1, index1) => {
      return (
        <div style={{ marginBottom: 12 }} key={index1} className='item'>
          <div className='title'>
            <span style={{ paddingRight: 10 }}> {index1 + 1}.</span>
            {item1.subject}
          </div>
          {item1.options ? (
            <Radio.Group value={item1.rightKey}>
              {this.renderOptions(item1.options)}
            </Radio.Group>
          ) : null}
        </div>
      )
    })
  }
  renderOptions = (list) => {
    return list.map((item2, index2) => {
      return (
        <Radio className='radioStyle' key={index2} value={item2.label}>
          {item2.label}
        </Radio>
      )
    })
  }
  timeChange = (e) => {
    this.setState({
      info: { ...this.state.info, minTime: e },
    })
    this.renderNotification()
  }
  addTopic = (e) => {
    let topicList = this.state.info.topicList
    switch (e) {
      case 'SINGLE_CHOICE':
        topicList.push({
          subject: '',
          options: [{ label: '' }, { label: '' }, { label: '' }, { label: '' }],
          type: 'SINGLE_CHOICE',
          position: topicList.length + 1 + '',
        })
        this.setState({
          info: { ...this.state.info },
        })
        this.renderNotification()
        break
      case 'wenda':
        topicList.push({
          subject: '',
          type: 'Q&A',
          position: topicList.length + 1 + '',
        })
        this.setState({
          info: { ...this.state.info },
        })
        this.renderNotification()
        break
    }
  }
  raidoChange = (index, index1) => {
    if (this.state.info.topicList[index].options[index1].label) {
      let list = this.state.info.topicList
      list[index].rightKey =
        this.state.info.topicList[index].options[index1].label
      this.setState({
        info: {
          ...this.state.info,
          topicList: list,
        },
      })
      this.renderNotification()
    }
  }
  deleteTopic = (index) => {
    let info = this.state.info
    info.topicList.splice(index, 1)
    this.setState({
      info,
    })
    this.renderNotification()
  }
  //添加选项
  addOptions = (index) => {
    let info = { ...this.state.info }

    info.topicList[index].options.push({ label: '' })
    this.setState({
      info,
    })
    this.renderNotification()
  }
  renderTopic = () => {
    const { info } = this.state
    return info.topicList.map((item, index) => {
      return (
        <Draggable
          key={item.position}
          draggableId={item.position}
          index={index}>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              style={getItemStyle(
                snapshot.isDragging,
                provided.draggableProps.style
              )}>
              <div key={index} className='topic'>
                <div className='title'>
                  <span style={{ paddingRight: 10 }}>{index + 1}.</span>
                  <Input
                    maxLength={30}
                    className='input'
                    allowClear
                    value={info.topicList[index].subject}
                    onChange={(e) => this.titleChange(e, index)}
                    placeholder='请输入问题'
                  />
                  {item.type == 'SINGLE_CHOICE' ? (
                    <Button
                      onClick={() => this.addOptions(index)}
                      style={{ marginLeft: 8 }}
                      disabled={item.options.length == 4}
                      type='primary'>
                      添加选项
                    </Button>
                  ) : null}
                </div>
                {item.options
                  ? item.options.map((item1, index1) => {
                      return (
                        <div key={index1} className='option'>
                          <Radio
                            className='radio'
                            onChange={() => this.raidoChange(index, index1)}
                            checked={
                              item1.label
                                ? this.state.info.topicList[index].rightKey ===
                                  item1.label
                                : false
                            }></Radio>
                          <Input
                            style={{ marginLeft: 20 }}
                            maxLength={20}
                            className='input'
                            allowClear
                            onChange={(e) =>
                              this.optionChange(e, index, index1)
                            }
                            placeholder='请输入选项'
                            value={item1.label}
                          />
                          {index1 > 1 ? (
                            <Icon
                              className='minus'
                              onClick={() => this.deleteOptions(index, index1)}
                              type='minus-circle'
                              theme='filled'
                            />
                          ) : null}
                        </div>
                      )
                    })
                  : null}
                <img
                  className='deleteImg'
                  onClick={() => this.deleteTopic(index)}
                  src={deleteImg}></img>
                <img className='dragImg' src={dragImg}></img>
              </div>
            </div>
          )}
        </Draggable>
      )
    })
  }
  deleteOptions = (index, index1) => {
    let info = this.state.info
    info.topicList[index].options.splice(index1, 1)
    this.setState({
      info,
    })
    this.renderNotification()
  }
  optionChange = (e, index, index1) => {
    let info = this.state.info
    if (
      !e.target.value &&
      info.topicList[index].options[index1].label ===
        info.topicList[index].rightKey
    ) {
      info.topicList[index].rightKey = ''
      this.setState({
        info,
      })
      this.renderNotification()
    }

    if (
      info.topicList[index].options[index1].label ==
      info.topicList[index].rightKey
    ) {
      info.topicList[index].rightKey = ''
    }
    info.topicList[index].options[index1].label = e.target.value
    this.setState({
      info,
    })
    this.renderNotification()
  }
  titleChange = (e, index) => {
    let info = this.state.info
    info.topicList[index].subject = e.target.value
    this.setState({
      info,
    })
    this.renderNotification()
  }
  //保存&发布问卷
  saveQuestion = (state) => {
    let info = this.state.info
    if (!info.minTime) {
      message.error('请选择完成问卷时间')
      return
    }
    let fault = false
    let hasSame = false
    info.topicList.forEach((item, index) => {
      if (!item.subject) {
        fault = true
      }
      if (item.options) {
        item.options.forEach((item1, index1) => {
          item.options.forEach((item2, index2) => {
            if (item2.label == item1.label && index1 != index2 && !hasSame) {
              hasSame = true
              message.error('第' + (index + 1) + '题存在相同选项')
            }
          })

          if (!item1.label) {
            fault = true
          }
        })
      }
    })
    if (hasSame) {
      return
    }
    if (fault) {
      message.error('问卷信息尚未填完')
      return
    }

    if (state === 'DRAFT') {
      info.topicList.forEach((item, index) => {
        item.position = index + 1 + ''
        item.option = JSON.stringify(item.options)
      })
      info.list = info.topicList
      info = { ...info, state, capsuleId: +this.state.capsuleId }
      delete info.topicList
      fetchSaveQuestion(info).then((res) => {
        if (res.success) {
          this.getRELEASEQuestion()
          this.setState({
            setState: false,
          })
          message.success('操作成功')
        }
      })
    } else if (state === 'RELEASE') {
      this.setState({
        release_visible: true,
      })
    }
  }

  release_OK = () => {
    let info = this.state.info

    info.topicList.forEach((item, index) => {
      item.position = index + 1 + ''
      item.option = JSON.stringify(item.options)
    })
    info.list = info.topicList
    info = { ...info, state: 'RELEASE', capsuleId: +this.state.capsuleId }
    delete info.topicList
    console.log(info)
    fetchSaveQuestion(info).then((res) => {
      if (res.success) {
        this.getRELEASEQuestion()
        this.setState(
          {
            setState: false,
            success_visible: true,
            release_visible: false,
          },
          () => {
            timeId = setInterval(() => {
              this.setState({
                countDown: this.state.countDown - 1,
              })
              if (this.state.countDown <= 0) {
                clearInterval(timeId)
              }
            }, 1000)
            setTimeout(() => {
              this.setState({
                success_visible: false,
              })
            }, 3000)
          }
        )
      } else {
        this.setState(
          {
            fail_visible: true,
            release_visible: false,
          },
          () => {
            timeId = setInterval(() => {
              this.setState({
                countDown: this.state.countDown - 1,
              })
              if (this.state.countDown <= 0) {
                clearInterval(timeId)
              }
            }, 1000)
            setTimeout(() => {
              this.setState({
                fail_visible: false,
              })
            }, 3000)
          }
        )
      }
    })
  }
  componentWillUnmount() {
    var that = this
    clearInterval(timeId)
    that.setInfo()
  }
  release_cancel = () => {
    this.setState({
      release_visible: false,
    })
  }
  handleCancel = () => {
    clearInterval(timeId)
    this.setState({
      success_visible: false,
      countDown: 3,
      fail_visible: false,
    })
  }

  render() {
    const {
      title,
      question,
      minTime,
      top,
      setState,
      questionnaireList,
      info,
      selected,
      release_visible,
      success_visible,
      fail_visible,
      countDown,
    } = this.state
    return (
      <div className='container'>
        <Headers BreadCrumbData={BreadCrumbData}></Headers>

        <div className='question_container'>
          <div
            style={{ marginBottom: 8 }}
            className={setState ? 'card' : 'card hidden'}>
            <Row>
              <Col span={8}>
                <Button
                  onClick={() => {
                    this.setState({
                      setState: false,
                    })
                    this.setInfo()
                  }}>
                  返回
                </Button>
                <span className='redPoint'>*</span>问卷信息会自动保存
              </Col>
              <Col span={16}>
                <Button
                  onClick={() => this.saveQuestion('RELEASE')}
                  className='fr '
                  type='primary'>
                  发布
                </Button>
                <Button
                  onClick={() => this.saveQuestion('DRAFT')}
                  className='fr mr'>
                  保存草稿
                </Button>
                <Button
                  disabled={!selected}
                  onClick={this.copyQuestionaire}
                  className='fr mr'
                  type='primary'>
                  复制问卷
                </Button>
                <Select
                  style={{ width: 180 }}
                  className='fr mr'
                  showSearch
                  placeholder='所有问卷'
                  allowClear
                  value={selected}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={this.selectChange}>
                  {questionnaireList.map((item) => {
                    return (
                      <Select.Option
                        item={item}
                        key={item.capsuleId || item.materialsId}
                        value={item.capsuleId || item.materialsId}>
                        {item.name}
                      </Select.Option>
                    )
                  })}
                </Select>
              </Col>
            </Row>
          </div>
          {/* 操作问卷界面 */}
          <div
            style={{ minHeight: '70vh' }}
            className={setState ? 'card1 active' : 'card1'}>
            <div className='questionTitle'>{info.title}</div>
            <div className='rules'>
              <span style={{ marginRight: 8 }}>问卷规则：</span>
              完成问卷时间不得少于
              <Select
                className='timeSelect'
                onChange={this.timeChange}
                value={info.minTime}>
                {timeList.map((item) => (
                  <Select.Option key={item} value={item}>
                    {item}秒
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div className='tips'>
              <Icon type='info-circle' theme='filled' />
              若该问题有正确答案，直接选中即可作为标准答案。
            </div>
            <DragDropContext onDragEnd={this.onDragEnd}>
              <Droppable droppableId='droppable'>
                {(provided, snapshot) => (
                  <div
                    //provided.droppableProps应用的相同元素.
                    {...provided.droppableProps}
                    // 为了使 droppable 能够正常工作必须 绑定到最高可能的DOM节点中provided.innerRef.
                    ref={provided.innerRef}>
                    {this.renderTopic()}

                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>

            <div className='rightContainer'>
              <div
                onClick={() => this.addTopic('SINGLE_CHOICE')}
                className='item item1'>
                <div className='img choice'></div>
                选择题
              </div>
              <div
                onClick={() => this.addTopic('wenda')}
                className='item item2'>
                <div className='img wenda'></div>
                问答题
              </div>
            </div>
          </div>
          <div
            style={{ marginBottom: 8 }}
            className={!setState ? 'card' : 'card hidden'}>
            <Row>
              <Col className='questionTitle' span={12}>
                <Button
                  onClick={() => {
                    this.props.history.goBack()
                  }}>
                  返回
                </Button>
              </Col>
              <Col span={12}>
                <Button
                  onClick={() =>
                    this.setState({
                      setState: true,
                    })
                  }
                  className='fr'
                  type='primary'>
                  设置问卷
                </Button>
              </Col>
            </Row>
          </div>
          <div className={setState ? 'hidden' : ''}>
            <div className={question.length === 0 ? 'card1 active' : 'card1'}>
              <img className='noQuestion' src={noQuestion}></img>
              <div className='word'>暂无问卷信息</div>
            </div>
            <div className={question.length !== 0 ? 'card1 active' : 'card1'}>
              <div className='questionTitle'>{title}</div>
              <div className='rules'>
                <span style={{ marginRight: 8 }}>问卷规则：</span>
                完成问卷时间不得少于{minTime}秒
              </div>
              {this.renderQuestion()}
            </div>
          </div>
          <img
            onClick={this.ScrollToTop}
            className={top > 300 ? 'up_top up_active' : 'up_top'}
            src={up}
            alt=''
          />
          <Modal
            title='发布提示'
            visible={release_visible}
            onOk={this.release_OK}
            onCancel={this.release_cancel}
            className='confirmModal'>
            <div style={{ padding: '24px 0', textAlign: 'center' }}>
              确认发布该调查问卷吗？
            </div>
          </Modal>
          <Modal
            title='发布结果'
            visible={success_visible}
            footer={null}
            onCancel={this.handleCancel}>
            <div className='relaseSuccess'>
              <Icon className='gou' type='check-circle' theme='filled' />
              <div className='word'>发布成功({countDown}s)</div>
            </div>
          </Modal>
          <Modal
            title='发布结果'
            visible={fail_visible}
            footer={null}
            onCancel={this.handleCancel}>
            <div className='relaseSuccess'>
              <Icon className='fail' type='close-circle' theme='filled' />
              <div style={{ marginBottom: 24 }} className='word'>
                发布失败({countDown}s)
              </div>
              <Button onClick={this.handleCancel} type='primary'>
                重新发布
              </Button>
            </div>
          </Modal>
        </div>
      </div>
    )
  }
}
export default Question
